/**
 * Exports of the lists of the product with the current filters (FR-CON-17): Excel through
 * write-excel-file, CSV for spreadsheets set to French.
 */
import writeXlsxFile from 'write-excel-file';
import { downloadCsv } from './csv';

export interface ExportColumn<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
  width?: number;
}

export async function exportRows<T>(
  fileName: string,
  columns: ExportColumn<T>[],
  rows: T[],
  format: 'xlsx' | 'csv',
) {
  const safe = fileName.replace(/[\\/:*?"<>|]+/g, '-');
  if (format === 'csv') {
    downloadCsv(`${safe}.csv`, [
      columns.map((c) => c.header),
      ...rows.map((r) =>
        columns.map((c) => {
          const v = c.value(r);
          return typeof v === 'number' ? String(v).replace('.', ',') : (v ?? '');
        }),
      ),
    ]);
    return;
  }
  const data = [
    columns.map((c) => ({
      value: c.header,
      fontWeight: 'bold' as const,
      backgroundColor: '#E6F4F1',
    })),
    ...rows.map((r) =>
      columns.map((c) => {
        const v = c.value(r);
        if (v === null || v === undefined || v === '') return null;
        return typeof v === 'number'
          ? { type: Number, value: v }
          : { type: String, value: String(v) };
      }),
    ),
  ];
  await writeXlsxFile(
    data as never,
    {
      fileName: `${safe}.xlsx`,
      columns: columns.map((c) => ({ width: c.width ?? 18 })),
    } as never,
  );
}
